
import { Link } from "react-router-dom";
import logo from "../assets/gooseLogo.png";
import googlePlay from "../assets/googlePlay.png";
import appStore from "../assets/appStore.png";
import Fb from '../assets/Fb.png';
import TikTok from '../assets/TikTok.png';
import Instagram from '../assets/Insta.png';
import Whatsapp from '../assets/whatsapp.png';
import { useTranslation } from "react-i18next";



export default function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <footer className="footer">
      <div className="container">
        {/* Top Footer */}
        <div className="top-footer d-flex justify-content-between gap-2">
          <div className="footer-logo">
            <Link to="/" className="logo-footer">
              <img src={logo} alt="Goose Logo" />
            </Link>
          </div>
          <div className="footer-right-social">
            <p>{t("footer.followUs")}</p>
            <ul className="p-0 m-0 list-unstyled d-flex align-items-center gap-2">
              <li>
                <Link
                  to="#"
                  className="social-footer d-flex align-items-center justify-content-center"
                >
                  <img src={Fb} alt="Facebook Logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="social-footer d-flex align-items-center justify-content-center"
                >
                  <img src={TikTok} alt="TikTok Logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="social-footer d-flex align-items-center justify-content-center"
                >
                  <img src={Instagram} alt="Instagram Logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="social-footer d-flex align-items-center justify-content-center"
                >
                  <img src={Whatsapp} alt="Whatsapp Logo" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom d-flex flex-wrap gap-2 justify-content-between">
          {/* Contact Section */}
          <div className="left-footer-contact">
            <h4>{t("footer.contact")}</h4>
            <p>{t("footer.address")}</p>
            <Link to="mailto:hi@viatours.com" className="link">
              hi@viatours.com
            </Link>
            <div className="speak-with d-flex align-items-center">
              <span>{t("footer.speakToExpert")} </span>
              <Link to="tel:1-800-453-6744" className="link">
                1-800-453-6744
              </Link>
            </div>
          </div>

          {/* Right Footer */}
          <div className="right-footer-contact d-flex justify-content-between gap-2">
            {/* Company */}
            <div className="footer-box">
              <h4>{t("footer.company.title")}</h4>
              <ul className="list-unstyled p-0 m-0">
                <li>
                  <Link to="/about-us" className="link">
                    {t("footer.company.about")}
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="link">
                    {t("footer.company.contact")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div className="footer-box">
              <h4>{t("footer.support.title")}</h4>
              <ul className="list-unstyled p-0 m-0">
                <li>
                  <Link to="/get-in-touch" className="link">
                    {t("footer.support.getInTouch")}
                  </Link>
                </li>
                <li>
                  <Link to="/help-center" className="link">
                    {t("footer.support.helpCenter")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Mobile Apps */}
            {/* Mobile Apps */}
            <div className="footer-box">
              <h4>{t("footer.apps.title")}</h4>
              <ul className="list-unstyled p-0 m-0">
                <li>
                  <Link to="#" className="link">
                    <img src={googlePlay} alt="Google Play" />
                  </Link>
                </li>
                <li>
                  <Link to="#" className="link">
                    <img src={appStore} alt="App Store" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
